import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/workshop/workshop_nota_parts`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_nota_parts/${id}`, options)
    .then(response => {
      let nota_parts = jsona.deserialize(response.data);
      delete nota_parts.links;
      return nota_parts;
    });
}

function add(nota_parts) {
  
  console.log(nota_parts);
  const payload = jsona.serialize({
    stuff: nota_parts,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/workshop/workshop_nota_parts`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(nota_parts) {
  const payload = jsona.serialize({
    stuff: nota_parts,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_nota_parts/${nota_parts.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

// function nota_part_date(daily_closing_date) {
//   const options = {
//     headers: {
//       'Accept': 'application/vnd.api+json',
//       'Content-Type': 'application/vnd.api+json',
//     }
//   };

//   return axios.get(`${url}/workshop/workshop_nota_parts?filter[created_at]=${daily_closing_date}`, options)
//   .then(response => {
//     return {
//       list: jsona.deserialize(response.data),
//       meta: response.data.meta
//     };
//   });
// }

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_nota_parts/${id}`, options);
}

function last_no() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_nota_parts/last/no`, options)
    .then(response => {
      return response.data;
    });
}


export default {
  list,
  get,
  add,
  update,
  destroy,
  last_no,
  // nota_part_date
};

